
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/program-guide/[[...slug]]",
      function () {
        return require("private-next-pages/program-guide/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/program-guide/[[...slug]]"])
      });
    }
  